import { render, staticRenderFns } from "./GenericContent.vue?vue&type=template&id=d0d59fce&"
import script from "./GenericContent.vue?vue&type=script&lang=js&"
export * from "./GenericContent.vue?vue&type=script&lang=js&"
import style0 from "./GenericContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports